import React, { type JSX } from 'react';
import { type SelectListItem } from '../../typings/viewModels/selectListItemViewModel';
import SelectLinkOptionWrapper from '../../../../archon/components/SelectLinkOptionWrapper/SelectLinkOptionWrapper';
import Select from '../Select/Select';
import type SpecsByClassSelectItemViewModel from '../../typings/viewModels/specsByClassSelectItemViewModel';
import VerticalContent from '../VerticalContent/VerticalContent';

type SpecSelectProps = {
  specOptions: SpecsByClassSelectItemViewModel[];
  selectedSpec: number;
  classLabel: string;
  specLabel: string;
  onChange?: (specId?: number) => void;
};

export default function SpecSelect({
  specOptions,
  selectedSpec,
  classLabel,
  specLabel,
  onChange,
}: SpecSelectProps): JSX.Element {
  const classOptions = getClassOptions(specOptions);
  const classOption = getClassOptionForSpec(
    specOptions,
    classOptions,
    selectedSpec,
  );

  return (
    <>
      <VerticalContent gap={'tiny'} style={{ minWidth: '130px' }}>
        <label>
          <b>{classLabel}</b>
        </label>
        <Select<SelectListItem>
          inputId='spec-select-class'
          value={classOption}
          options={classOptions}
          OptionWrapper={SelectLinkOptionWrapper}
          onChange={(option) => onChange?.(option?.value)}
          aria-label={classLabel}
          usesEnhancedMarkdown
          id={'spec-select-class'}
        />
      </VerticalContent>
      <VerticalContent gap={'tiny'} style={{ minWidth: '130px' }}>
        <label>
          <b>{specLabel}</b>
        </label>
        <Select<SelectListItem>
          inputId='spec-select-spec'
          value={
            specOptions
              .flatMap((x) => x.options)
              .find((x) => x.value === selectedSpec) ??
            specOptions[0].options[0]
          }
          options={
            (
              specOptions.find((x) => x.className === classOption.label) ??
              specOptions[0]
            ).options
          }
          OptionWrapper={SelectLinkOptionWrapper}
          onChange={(option) => onChange?.(option?.value)}
          aria-label={specLabel}
          usesEnhancedMarkdown
          id={'spec-select-spec'}
        />
      </VerticalContent>
    </>
  );
}

function getClassOptions(
  specOptions: SpecsByClassSelectItemViewModel[],
): SelectListItem[] {
  return specOptions.map((x) => ({
    value: x.options[0].value,
    label: x.className,
    url: x.options[0].url,
  }));
}

function getClassOptionForSpec(
  specOptions: SpecsByClassSelectItemViewModel[],
  classOptions: SelectListItem[],
  selectedSpec: number,
): SelectListItem {
  const className = (
    specOptions.find((x) => x.options.some((y) => y.value === selectedSpec)) ??
    specOptions[0]
  ).className;

  return classOptions.find((x) => x.label === className) ?? classOptions[0];
}
